import React, { useEffect, useState, useRef } from "react";
import { Image } from "react-bootstrap";
import { Link } from "react-router-dom";
import moment from "moment/moment";
import {
  Header,
  Popover,
  Card,
  Text,
  CardGroup,
} from "rsuite";
import axios from "../axiosIn";

export const Main = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768); // Initial check
  const initialized = useRef(false);
  const [strava, setStrava] = useState("");
  const [ubica, setUbica] = useState("");
  const [docConvoca, setDocConvoca] = useState("");
  const [fecRecon1, setFecRecon1] = useState("");
  const [fecRecon2, setFecRecon2] = useState("");
  const [horaRecon1, setHoraRecon1] = useState("");
  const [horaRecon2, setHoraRecon2] = useState("");
  const [fecCierre, setFecCierre] = useState("");
  const [horaCierre, setHoraCierre] = useState("");
  const [ruta1, setRuta1] = useState("");
  const [ruta2, setRuta2] = useState("");
  const [linkRuta1, setLinkRuta1] = useState("");
  const [linkRuta2, setLinkRuta2] = useState("");
  const [fechasRecon, setFechasRecon] = useState("");
  const [textoUbica, setTextoUbica] = useState("");
  const [cierraEvento, setCierraEvento] = useState(0);

  const getData = async () => {
    const abortController = new AbortController();
    var url = `DatosCarrera/getDataInicio`;

    try {
      const response = await axios.get(url, { signal: abortController.signal });
      setStrava(response.data.Strava);
      setFecRecon1(response.data.FechaRecon1);
      setHoraRecon1(response.data.horaRecon1);
      setFecRecon2(response.data.FechaRecon2);
      setHoraRecon2(response.data.horaRecon2);
      setUbica(response.data.LinkUbicacion);
      setFecCierre(response.data.FechaCierre);
      setHoraCierre(response.data.HoraCierre);

      setFechasRecon(response.data.fechasRecon);
      setTextoUbica(response.data.TextUbicacion);
      setRuta1(response.data.Ruta1);
      setRuta2(response.data.Ruta2);
      setLinkRuta1(response.data.linkRuta1);
      setLinkRuta2(response.data.linkRuta2);
      setCierraEvento(response.data.CierreEvento);
      setDocConvoca(response.data.DocConvoca);
      
    } catch (error) {
      if (abortController.signal.aborted) {
        console.log("Data fetching cancelled");
      } else {
        // Handle error
        console.log("Err_carga");
      }
    }
  };

  const speaker = (
    <Popover title="Rutas">
      <p>
        <a
          href={linkRuta1}
          style={{ fontSize: "18px" }}
          rel="noreferrer"
          target="_blank"
        >
          {ruta1}
        </a>
      </p>
      <p>
        <a
          href={linkRuta2}
          style={{ fontSize: "18px" }}
          rel="noreferrer"
          target="_blank"
        >
          {ruta2}
        </a>
      </p>
    </Popover>
  );

  const setCookie = (name, value, hours) => {
    document.cookie = `${name}=${value};`;
    document.cookie = `expira=${moment().add(hours, "h").format()};`;
    document.cookie = `sessionID=${crypto.randomUUID()};`;
  };

  const goTo = (page, windowOut) => {
    if (cierraEvento === 1) {
      window.location.href = "#/CierreEvento";
    } else {
      if (windowOut === 0) {
        window.location = `/#/${page}`;
      } else {
        window.open(page, "_blank");
      }
    }
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768); // Update on resize
    };
    if (!initialized.current) {
      initialized.current = true;
      getData();
    }
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize); // Cleanup
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      style={{
        backgroundImage: `url(Images/fondoRespon.jpg?v=${new Date().getTime()})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "98% 98%",
        backgroundPosition: "center",
        minHeight: "100%",
        height: "auto",
        position: "fixed",
        top: 0,
        height: "100%",
        width: "100%",
        overflow: "auto",
      }}
    >
      <div
        className="container"
        style={{
          margin: "auto",
          marginTop: "5%",
          width: "60%",
          marginLeft: "20%",
          padding: "10px",
        }}
      >
        <Header
          style={{
            backgroundColor: "#f9f7f6",
            height: "auto",
            padding: "20px",
            borderRadius: "15px",
            width: "auto",
            opacity: 0.9,
          }}
        >
          
          <CardGroup columns={isMobile ? 1 : 4} spacing={5}>
            <Card shaded>
              <img src="/Images/bikers.jpg" style={{ height: isMobile ? '60px' : '200px'}} alt="Shadow" />
              <Card.Body>
                <Text size={isMobile ? "xs" : "md"}>
                  Cierre de inscripciones:
                  <b>{fecCierre}</b> <br></br>
                  Horario: <b>{horaCierre}</b>
                </Text>
              </Card.Body>
              <Card.Footer>
                <Link
                  to={"/DatosIniciales"}
                  style={{
                    color: "#008bf8",
                    fontSize: isMobile ? "12px" : "16px",
                    fontWeight: "600",
                  }}
                >
                  Inscribete aquí
                </Link>
              </Card.Footer>
            </Card>
            <Card shaded>
              <img src="/Images/strava.png" style={{ height: isMobile ? '60px' : '200px'}} alt="Shadow" />
              <Card.Body>
                <Text size={isMobile ? "sm" : "md"}>Pistas</Text>
              </Card.Body>
              <Card.Footer>
                <Link
                  to={linkRuta1}
                  target="_blank"
                  style={{
                    color: "#008bf8",
                    fontSize: isMobile ? "12px" : "16px",
                    fontWeight: "600",
                  }}
                > 
                {ruta1}
                </Link>
                <Link
                  to={linkRuta2}
                  target="_blank"
                  style={{
                    color: "#008bf8",
                    fontSize: isMobile ? "12px" : "16px",
                    fontWeight: "600",
                  }}
                > 
                {ruta2}
                </Link>
              </Card.Footer>
            </Card>

            <Card shaded>
              <img src="/Images/mapPoint.jpg" style={{ height: isMobile ? '60px' : '200px'}} alt="Shadow" />
              <Card.Body>
                <Text size={isMobile ? "sm" : "md"}>Ubicación de salida</Text>
              </Card.Body>
              <Card.Footer>
                <Link
                  onClick={() => goTo(ubica, 1)}
                  target="_blank"
                  style={{
                    color: "#008bf8",
                    fontSize: isMobile ? "12px" : "16px",
                    fontWeight: "600",
                  }}
                > 
                {textoUbica}
                </Link>
              </Card.Footer>
            </Card>

            <Card shaded>
              
              <img src="/Images/Recon1.jpg" style={{ height: isMobile ? '60px' : '200px'}} alt="Shadow" />
              <Card.Body>
                <Text size={isMobile ? "sm" : "md"}>Fechas de Reconocimiento</Text>
              </Card.Body>
              <Card.Footer>
                <Link
                  onClick={() => goTo(ubica, 2)}
                  target="_blank"
                  style={{
                    color: "#008bf8",
                    fontSize: isMobile ? "12px" : "16px",
                    fontWeight: "600",
                  }}
                > 
                {fechasRecon}
                <br></br>
                Hora de inicio: {horaRecon1}
                </Link>
              </Card.Footer>
            </Card>

          </CardGroup>
          <br></br>
          {/* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>  ACTIVAR PARA CONVOCATORIA <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */}
          
          <div className="row mb-2">
            <div className="col text-center">
              {/* <Link><b>Dudas llamanos al: 444.225.2948</b></Link> */}
              <a
                href={`Docs/${docConvoca}`}
                target="_blank"
                style={{
                  backgroundColor: "#f44336",
                  display: "block",
                  color: "white",
                  textDecoration: "none",
                  padding: "14px 25px",
                  borderRadius: "15px",
                  width: "auto",
                }}
              >
                Convocatoria
              </a>
            </div>
          </div>
          
          <div className="row">
            <div className="text-center col">
              <Image
                src="/Images/Logo.png"
                height={isMobile ? "50px" : "90px"}
                style={{ borderRadius: "10px", cursor: "pointer" }}
                onClick={() => goTo("https://www.masmtb.com/", 1)}
              />
            </div>
            <center><span style={{ fontSize: '10px'}}>© RADYXXA México {new Date().getFullYear()} - Ver. 2.07</span></center>
          </div>
        </Header>
      </div>
    </div>
  );
};
